<template>
  <div style="display: inline-block" class="flex-grow-1">
    <v-btn
        color="teal white--text"
        x-small fab
        @click="next"
    >
      <v-icon>double_arrow</v-icon>
    </v-btn>
  </div>
</template>

<script>
import OrderProvider from "@/modules/delivery/providers/OrderProvider";

export default {
  name: "OrderNextDrinkFlowState",
  props: {
    order: {type: Object},
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {

    async next() {
      try {
        this.loading = true

        if(this.order.drinkState === 'WAITING'){
          await this.updateOrderDrinkState('SERVED')
          this.order.drinkState = 'SERVED'
          this.$emit("orderUpdated",this.order)
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    async updateOrderDrinkState(drinkState) {
      return await OrderProvider.updateOrderDrinkState({id: this.order.id, drinkState: drinkState})
    },
  }
}
</script>


